(function () {
  const drawer = document.querySelector("[data-supercat-cart-drawer]");
  if (!drawer) return;

  const panel = drawer.querySelector(".sc-cart-drawer__panel");
  const itemsNode = drawer.querySelector("[data-sc-cart-items]");
  const emptyNode = drawer.querySelector("[data-sc-cart-empty]");
  const footerNode = drawer.querySelector("[data-sc-cart-footer]");
  const subtotalNode = drawer.querySelector("[data-sc-cart-subtotal]");
  const savingsNode = drawer.querySelector("[data-sc-cart-savings]");
  const totalNode = drawer.querySelector("[data-sc-cart-total]");
  const shippingNode = drawer.querySelector("[data-sc-cart-shipping]");
  const fallbackImage = drawer.dataset.fallbackImage || "";
  const moneyFormat = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  const sellableCountries = new Set(["US", "CA"]);
  let closeTimer = null;
  let lastOfferContext = null;

  const formatPrice = (cents) => moneyFormat.format((Number(cents) || 0) / 100);
  const formatMoney = (cents) => `${formatPrice(cents)} USD`;
  const text = (value) => String(value || "").replace(/\s+/g, " ").trim();
  const cookieValue = (name) => document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split("=")
    .slice(1)
    .join("=") || "";

  const currentCountry = () => {
    const localization = decodeURIComponent(cookieValue("localization")).toUpperCase();
    if (localization) return localization;
    return String(window.Shopify?.country || "").toUpperCase();
  };

  const ensureSellableMarket = async (force = false) => {
    const country = currentCountry();
    if (!force && sellableCountries.has(country)) return;

    const body = new URLSearchParams();
    body.set("form_type", "localization");
    body.set("utf8", "✓");
    body.set("_method", "put");
    body.set("country_code", "US");
    body.set("return_to", `${window.location.pathname}${window.location.search}`);

    await fetch("/localization", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "text/html, application/xhtml+xml",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    }).catch(() => {});

    document.cookie = "localization=US; path=/; max-age=31536000; SameSite=Lax";
    document.cookie = "cart_currency=USD; path=/; max-age=1209600; SameSite=Lax";
  };

  const tomorrowLabel = () => {
    const now = new Date();
    const cutoff = new Date(now);
    cutoff.setHours(24, 0, 0, 0);
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    const msLeft = Math.max(0, cutoff - now);
    const hours = Math.floor(msLeft / 3600000);
    const minutes = Math.floor((msLeft % 3600000) / 60000);
    const date = tomorrow.toLocaleDateString("en-US", { month: "short", day: "2-digit" });
    return `Ships <strong>Tomorrow, ${date}</strong> if Ordered Within <strong>${hours} hr ${String(minutes).padStart(2, "0")} mins</strong>`;
  };

  const updateShipping = () => {
    if (shippingNode) shippingNode.innerHTML = tomorrowLabel();
  };

  const openDrawer = () => {
    window.clearTimeout(closeTimer);
    drawer.hidden = false;
    document.body.classList.add("sc-cart-drawer-open");
    requestAnimationFrame(() => {
      drawer.classList.add("is-open");
      panel?.focus({ preventScroll: true });
    });
  };

  const closeDrawer = () => {
    drawer.classList.remove("is-open");
    document.body.classList.remove("sc-cart-drawer-open");
    closeTimer = window.setTimeout(() => {
      drawer.hidden = true;
    }, 280);
  };

  const fetchCart = async () => {
    const response = await fetch(`/cart.js?ts=${Date.now()}`, {
      cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Unable to load cart.");
    return response.json();
  };

  const changeLine = async (key, quantity) => {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error("Unable to update cart.");
    return response.json();
  };

  const imageMarkup = (item) => {
    const image = item.image || fallbackImage;
    if (image) {
      return `<img class="sc-cart-item__image" src="${image}" alt="${escapeHtml(item.product_title || "SuperCat product")}" loading="lazy">`;
    }
    return '<div class="sc-cart-item__image-fallback">SuperCat</div>';
  };

  const escapeHtml = (value) => text(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

  const propertyValue = (item, key) => {
    const properties = item.properties || {};
    if (Array.isArray(properties)) {
      const property = properties.find((entry) => entry && (entry.name === key || entry[0] === key));
      return property?.value ?? property?.[1] ?? "";
    }
    return properties[key] || "";
  };

  const compareAtUnit = (item) => {
    const fromProperty = Number(propertyValue(item, "_sc_compare_at_unit"));
    if (fromProperty > 0) return fromProperty;
    return Math.max(Number(item.original_price) || 0, Number(item.final_price) || 0);
  };

  const itemDelivery = (item) => {
    const delivery = propertyValue(item, "_sc_delivery");
    if (delivery) return delivery;
    return item.selling_plan_allocation ? "Delivered on subscription" : "One-time purchase";
  };

  const contextForItem = (item, index) => {
    if (index === 0 && lastOfferContext) return lastOfferContext;
    const boxes = propertyValue(item, "_sc_boxes");
    const variantTitle = boxes || (item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : `${item.quantity} Box`);
    return {
      amount: `Amount: ${variantTitle}`,
      delivery: itemDelivery(item),
    };
  };

  const renderError = (message) => {
    itemsNode.innerHTML = `<p class="sc-cart-drawer__error">${escapeHtml(message)}</p>`;
    emptyNode.hidden = true;
    footerNode.hidden = true;
    openDrawer();
  };

  const renderCart = (cart) => {
    updateShipping();
    const hasItems = cart.items && cart.items.length > 0;
    emptyNode.hidden = hasItems;
    footerNode.hidden = !hasItems;
    itemsNode.hidden = !hasItems;

    if (!hasItems) {
      itemsNode.innerHTML = "";
      openDrawer();
      return;
    }

    itemsNode.innerHTML = cart.items.map((item, index) => {
      const context = contextForItem(item, index);
      return `
        <article class="sc-cart-item" data-cart-key="${escapeHtml(item.key)}">
          ${imageMarkup(item)}
          <div class="sc-cart-item__body">
            <h3 class="sc-cart-item__title">${escapeHtml(item.product_title || item.title)}</h3>
            <p class="sc-cart-item__price">${formatPrice(item.final_price)}${compareAtUnit(item) > item.final_price ? ` <s>${formatPrice(compareAtUnit(item))}</s>` : ""}</p>
            <p class="sc-cart-item__meta">${escapeHtml(context.amount)}</p>
            <p class="sc-cart-item__meta">${escapeHtml(context.delivery)}</p>
            <div class="sc-cart-item__controls">
              <div class="sc-cart-qty" aria-label="Quantity selector">
                <button type="button" data-sc-cart-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-sc-cart-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
              <button class="sc-cart-item__remove" type="button" data-sc-cart-remove aria-label="Remove ${escapeHtml(item.product_title || item.title)}"><span aria-hidden="true"></span></button>
            </div>
          </div>
          <strong class="sc-cart-item__line-price">${formatPrice(item.final_line_price)}</strong>
        </article>
      `;
    }).join("");

    const compareSubtotal = cart.items.reduce((sum, item) => sum + compareAtUnit(item) * item.quantity, 0);
    const subtotal = compareSubtotal || cart.items_subtotal_price || cart.original_total_price || cart.total_price;
    const savings = Math.max(0, subtotal - cart.total_price);
    subtotalNode.textContent = formatMoney(subtotal);
    savingsNode.textContent = formatMoney(savings);
    totalNode.textContent = formatMoney(cart.total_price);
    openDrawer();
  };

  const selectedText = (root, selector) => {
    const selected = root?.querySelector(selector);
    return text(selected?.innerText || selected?.textContent);
  };

  const conciseAmount = (rawAmount) => {
    const normalized = text(rawAmount);
    const packageMatch = normalized.match(/\b([123])\s+Boxes?\b/i);
    if (packageMatch) return `${packageMatch[1]} ${Number(packageMatch[1]) === 1 ? "Box" : "Boxes"}`;
    const bottleMatch = normalized.match(/\b([0-9]+)\s+Bottles?\b/i);
    if (bottleMatch) return `${bottleMatch[1]} ${Number(bottleMatch[1]) === 1 ? "Bottle" : "Bottles"}`;
    const sachetMatch = normalized.match(/\b([0-9]+)\s+sachets?\b/i);
    if (sachetMatch) return `${sachetMatch[1]} sachets`;
    return normalized.split(/\n|Free shipping|\+ \$4\.95 shipping|—|\$/)[0] || normalized;
  };

  const collectOfferContext = (form) => {
    const root = form.closest(".pg-choose-box, .shopify-product-box, .offer-panel, section") || document;
    const selectedPackage = selectedText(root, ".pg-package-card.is-selected, .pg-package-card:has(input:checked), .package-card.selected, .package-card:has(input:checked)");
    const selectedPurchase = selectedText(root, ".pg-purchase-toggle .is-selected, .pg-purchase-toggle label:has(input:checked)");
    const selectedVariant = selectedText(form, ".package-card.selected, .package-card:has(input:checked)");
    const rawAmount = selectedPackage || selectedVariant;
    const packageTitle = conciseAmount(rawAmount);
    const selectedCard = form.querySelector(".offer-card.selected, .offer-card input:checked")?.closest(".offer-card");
    return {
      amount: packageTitle ? `Amount: ${packageTitle}` : `Amount: ${selectedCard?.dataset.boxLabel || "1 Box"}`,
      delivery: selectedCard?.dataset.delivery && !/one-time/i.test(selectedPurchase) ? selectedCard.dataset.delivery : "One-time purchase",
    };
  };

  const selectedOfferCard = (form) => form.querySelector(".offer-card.selected, .offer-card input:checked")?.closest(".offer-card");
  const selectedPurchaseType = (form) => form.querySelector('input[name="purchase_option"]:checked')?.value || "one-time";

  const normalizeCartFormData = (form, formData) => {
    const selectedCard = selectedOfferCard(form);
    const checkedId = selectedCard?.querySelector('input[name="id"]') || form.querySelector('input[name="id"]:checked, input[name="id"]');
    const isSubscription = selectedPurchaseType(form) === "subscription";
    const sellingPlan = selectedCard?.dataset.sellingPlanId || form.querySelector("[data-sc-selling-plan]")?.value || "";

    if (isSubscription && !sellingPlan) {
      throw new Error("Subscriptions are temporarily unavailable. Please choose One-Time Purchase or try again shortly.");
    }

    if (checkedId?.value) formData.set("id", checkedId.value);
    if (!formData.get("quantity")) formData.set("quantity", "1");
    formData.delete("purchase_option");

    if (isSubscription && sellingPlan) {
      formData.set("selling_plan", sellingPlan);
    } else {
      formData.delete("selling_plan");
    }

    return formData;
  };

  const cartPayloadFromFormData = (formData) => {
    const properties = {};
    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    });

    const item = {
      id: Number(formData.get("id")),
      quantity: Number(formData.get("quantity")) || 1,
    };

    const sellingPlan = formData.get("selling_plan");
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    if (Object.keys(properties).length) item.properties = properties;

    return { items: [item] };
  };

  const parseCartError = async (response) => {
    let message = "We couldn't add that item to your cart. Please try again.";
    try {
      const payload = await response.json();
      message = payload.description || payload.message || message;
    } catch (error) {}
    return message;
  };

  const postCartAdd = (formData) => fetch("/cart/add.js", {
    method: "POST",
    cache: "no-store",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(cartPayloadFromFormData(formData)),
  });

  const fetchVerifiedCart = async (formData) => {
    const cart = await fetchCart();
    const sellingPlan = Number(formData.get("selling_plan"));
    if (!sellingPlan) return cart;

    const variantId = Number(formData.get("id"));
    const hasSubscriptionLine = cart.items.some((item) => (
      Number(item.variant_id) === variantId
      && Number(item.selling_plan_allocation?.selling_plan?.id) === sellingPlan
    ));

    if (!hasSubscriptionLine) {
      throw new Error("The subscription could not be verified in your cart. Your order was not changed to a one-time purchase.");
    }

    return cart;
  };

  const addFormToCart = async (form) => {
    await ensureSellableMarket();

    const formData = normalizeCartFormData(form, new FormData(form));
    lastOfferContext = collectOfferContext(form);

    let response = await postCartAdd(formData);

    if (!response.ok) {
      let message = await parseCartError(response);
      const canRetryMarket = /sold out|unavailable|cannot be purchased/i.test(message) && !sellableCountries.has(currentCountry());
      if (canRetryMarket) {
        await ensureSellableMarket(true);
        response = await postCartAdd(formData);
        if (response.ok) return fetchVerifiedCart(formData);
        message = await parseCartError(response);
      }

      throw new Error(message);
    }

    return fetchVerifiedCart(formData);
  };

  const handleCartSubmit = async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.scCartNative === "true") return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) {
      submitter.disabled = true;
      submitter.dataset.originalText = submitter.textContent;
      submitter.textContent = "Adding...";
    }

    try {
      const cart = await addFormToCart(form);
      renderCart(cart);
    } catch (error) {
      renderError(error.message);
    } finally {
      if (submitter) {
        submitter.disabled = false;
        submitter.textContent = submitter.dataset.originalText || "Add to Cart";
      }
    }
  };

  document.addEventListener("submit", handleCartSubmit, true);

  drawer.addEventListener("click", async (event) => {
    if (event.target.closest("[data-sc-cart-close]")) {
      closeDrawer();
      return;
    }

    const line = event.target.closest(".sc-cart-item");
    if (!line) return;
    const key = line.dataset.cartKey;

    const remove = event.target.closest("[data-sc-cart-remove]");
    const quantityButton = event.target.closest("[data-sc-cart-qty]");
    if (!remove && !quantityButton) return;

    event.preventDefault();
    const quantity = remove ? 0 : Number(quantityButton.dataset.scCartQty);
    try {
      const cart = await changeLine(key, Math.max(0, quantity));
      renderCart(cart);
    } catch (error) {
      renderError(error.message);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !drawer.hidden) closeDrawer();
  });

  document.addEventListener("click", async (event) => {
    const trigger = event.target.closest('[data-sc-open-cart], a[href="/cart"], a[href$="/cart"]');
    if (!trigger || trigger.closest('form[action*="/cart/add"]')) return;
    event.preventDefault();
    try {
      renderCart(await fetchCart());
    } catch (error) {
      renderError(error.message);
    }
  });

  updateShipping();
  window.setInterval(updateShipping, 60000);
})();
